import { SelectNoContentCallable } from '@/components/Select/types';

export const cityNoContent: SelectNoContentCallable = (buffer, processing, { notFound }) => {
  if (processing) return 'Buscando cidades...';
  if (buffer.length < 2) return 'Digite ao menos 2 caracteres para iniciar a busca.';
  return notFound;
};
